import { createStore } from '../.'

import type { StateStorage } from 'zustand/middleware'
import type { PlugToken, PlugTokenGroup } from '../../interfaces/common'

interface TokenStore {
  tokens: PlugToken[]
  tokenGroups: PlugTokenGroup[]
  setTokens: (tokens: PlugToken[]) => void
  setTokenGroups: (tokenGroups: PlugTokenGroup[]) => void
}

export const createTokenStore = (storage: StateStorage) =>
  createStore<TokenStore>(
    storage,
    (set) => ({
      tokens: [],
      tokenGroups: [],
      setTokens(tokens) {
        set({
          tokens,
        })
      },
      setTokenGroups(tokenGroups) {
        set({
          tokenGroups,
        })
      },
    }),
    {
      persist: {
        name: 'dabTokens',
        version: 0,
      },
    }
  )
